import { apiGet } from '../api.ts'
import { useQuery } from '@tanstack/react-query'
import { QueryCacheKeys } from '@/api/queryKeys.ts'
import { MINUTE } from '@/constant/time.ts'

export const apiGetUsersCount = async () => {
    return await apiGet<IUserCount>(`/protectee/summary/count`)
}

const useQueryGetUsersCount = (enabled = false) => {
    return useQuery({
        enabled: enabled,
        queryKey: QueryCacheKeys.user.getUsersCount(),
        refetchInterval: 1 * MINUTE,
        queryFn: async () => {
            const { data } = await apiGetUsersCount()
            return data
        }
    })
}

export default useQueryGetUsersCount

export interface IUserCount {
    total: number
}
